import { alpha, Box, Tooltip, useTheme } from '@mui/material';

export const SideNavButton = ({ icon, label, isActive, onClick, onMouseOver, dataTestId, tooltip }) => {
  const theme = useTheme(); // Get the theme object

  // Define active background color
  const activeBgColor = theme.palette.mode !== 'dark' ? theme.palette.primary.main : theme.palette.primary.dark;
  const hoverBgColor = isActive
    ? alpha(theme.palette.primary.dark, 0.6) // Slightly darker version of active color on hover
    : theme.palette.action.hover; // Standard hover color

  return (
    <Tooltip title={tooltip}>
      <Box
        data-test-id={dataTestId}
        sx={{
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          padding: theme.spacing(1),
          flexDirection: 'column',
          fontSize: '12px',
          marginBottom: '5px',
          width: '100%'
        }}
        onClick={onClick}
        onMouseOver={onMouseOver}
      >
        <Box
          sx={{
            marginBottom: '3px',
            width: '80%',
            padding: '8px',
            borderRadius: '20px',
            transition: 'background-color 0.2s ease-in-out',
            backgroundColor: isActive ? activeBgColor : null, // Active background color
            '&:hover': {
              backgroundColor: hoverBgColor, // Slightly darker when hovered
            },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          {icon}
        </Box>
        {label}
      </Box>
    </Tooltip>
  )
}